import { assetsDirectory } from '../constants';
import React, { Component } from 'react';
import _ from 'lodash';
import { render } from 'react-dom';
import axios from 'axios';
import Helper from 'helpers/util';
import '../libs/markerclusterer';
import LocationSearch from '../components/LocationSearch';
import { appboyLogCustomEvent } from '../account/apis/Appboy';

const storeFinderEl = document.getElementById('store-finder-app');
const storeListEndpoint = window.storeFinderApiEndpoint
	? window.storeFinderApiEndpoint
	: '/js/stores.json';

class StoreFinder extends Component {
	constructor() {
		super();

		// default map position around australia
		this.initialZoom = 5;
		this.initialLat = -24.994167;
		this.initialLng = 134.866944;

		// settings
		this.maxResults = 10; // max number of results to show in sidebar
		this.autoGeolocate = false; // if true then run geolocation on init
		this.locationZoom = 13; // zoom level for searched location

		// initial state
		this.state = {
			loading: true,
			viewportHeight: window.innerHeight,
			storeResults: [],
			searchLocation: null,
			filtersExpanded: false,
			filters: [
				{
					name: 'preorder',
					label: 'Pre-order',
					icon: 'icon-preorder',
				},
				{
					name: 'drivethru',
					label: 'Drive Thru',
					icon: 'icon-drivethrough',
				},
				{
					name: 'barista_coffee',
					label: "Jack's Cafe",
					icon: 'icon-barista-coffee',
				},
				{
					name: 'birthdayparty',
					label: 'Delivery',
					icon: 'icon-delivery-scooter',
				},
				{
					name: 'is24x7',
					label: '24/7',
					icon: 'icon-24hrs',
				},
				{
					name: 'is24x2',
					label: '24hrs Sat & Sun',
					icon: 'icon-24hrsWeekend',
				},
				{
					name: 'foodcourt',
					label: 'Food Court',
					icon: 'icon-foodcourt',
				},
				{
					name: 'playground',
					label: 'Playground',
					icon: 'icon-playground',
				},
			],
		};

		// function bindings
		this.newLocation = this.newLocation.bind(this);
	}

	componentDidMount() {
		// bind events
		this.attachEvents();

		// define google maps render div
		this.mapElement = document.getElementById('store-finder-map');

		// load store list
		axios.get(storeListEndpoint).then((response) => {
			if (response.status === 200 && response.data) {
				this.stores = response.data;
				this.init();
			} else {
				console.error(
					'There was an error loading the store list json. Please check the network tab for more information.'
				);
			}
		});

		// set initial sidebar height/padding
		this.setSidebarScrollHeight();

		// start set window height viewport update
		this.onRequestAnimationFrame();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.filtersExpanded !== this.state.filtersExpanded) {
			// filter expand has changed so update height/padding
			this.setSidebarScrollHeight();
		}

		// show/hide mobile nav functionality
		if (this.state.searchLocation) {
			let nav = document.querySelector('nav');
			nav.classList.add('sf-hide-nav');
		} else {
			let nav = document.querySelector('nav');
			nav.classList.remove('sf-hide-nav');
		}

		// Scroll to active store result
		let storeResultScrollSelector = document.querySelector('.is-scroll-to');
		if (storeResultScrollSelector) {
			document.getElementById('store-finder-results').scrollTop =
				storeResultScrollSelector.offsetTop;
		}
	}

	attachEvents() {
		// google maps loaded event
		Helper.pubsub.subscribe('googleMapsLoaded', () => {
			// update google maps load state
			this.gMapsLoaded = true;
			// init store finder
			this.init();
		});
		// window hash change event
		Helper.pubsub.subscribe('onWindowResize', () => {
			this.windowResized();
		});
	}

	windowResized() {
		// only resize and center map to whole of australia if no search location entered
		if (this.gMapsLoaded && !this.state.searchLocation) {
			this.map.setCenter(this.centerPosition);
			this.map.setZoom(this.initialZoom);
		}

		this.setSidebarScrollHeight();
	}

	init() {
		// check to make sure google maps and store list are both loaded
		if (this.gMapsLoaded && this.stores) {
			//this.updateLocation();
			this.initMap();
		}
	}

	initMap() {
		// map options
		this.mapOptions = {
			//draggable: false,
			//zoomControl: false,
			//scrollwheel: false,
			gestureHandling: window.isMobileMode() ? 'greedy' : '',
			disableDoubleClickZoom: true,
			zoom: this.initialZoom,
			center: new window.google.maps.LatLng(this.initialLat, this.initialLng),
			//disableDefaultUI : true,
			streetViewControl: false,
			mapTypeControl: false,
			fullscreenControl: false,
			styles: [
				{
					featureType: 'poi',
					stylers: [{ visibility: 'off' }],
				},
			],
		};

		// map setup
		this.map = new window.google.maps.Map(this.mapElement, this.mapOptions);
		this.centerPosition = this.map.getCenter();

		// add store markers/clusters to map
		this.updateStoreMarkers();

		// idle event for updating results based off stores in map bounds
		window.google.maps.event.addListener(this.map, 'idle', () => {
			// set state for markers(stores) within map viewport bounds and display in side bar
			if (this.filteredStores) {
				this.setStoreResults(this.filteredStores);
			} else {
				this.setStoreResults(this.stores);
			}
		});

		// check url hash
		if (document.location.hash) {
			const hashAddress = decodeURIComponent(document.location.hash).replace(
				'#',
				''
			);
			// geocode formatted hash address
			if (hashAddress) {
				this.geocodeAddress(hashAddress);
			}
		} else {
			// set app loaded state
			this.setState({
				loading: false,
			});
		}
	}

	onRequestAnimationFrame() {
		window.requestAnimationFrame(() => {
			this.onRequestAnimationFrame();
		});

		if (this.state.viewportHeight !== window.innerHeight) {
			this.setState({
				viewportHeight: window.innerHeight,
			});
		}

		// update class on google maps info window (marker label)
		const infoWindow = document.getElementsByClassName('gm-style-iw')[0];
		if (infoWindow && !infoWindow.className.match(/\bgm-marker-label\b/)) {
			infoWindow.parentNode.classList.add('gm-marker-label');
		}
	}

	updateStoreMarkers() {
		let storesToMarkers = this.filteredStores
			? this.filteredStores
			: this.stores;

		// clear old markers if they exist
		if (this.markerCluster) {
			this.markerCluster.clearMarkers();
		}

		// default marker style
		let markerIconStyle = {
			url: assetsDirectory + 'images/store-marker.png',
			size: new window.google.maps.Size(44, 60),
			origin: new window.google.maps.Point(0, 0),
			anchor: new window.google.maps.Point(22, 60),
			scaledSize: new window.google.maps.Size(44, 60),
		};
		// coffee marker style
		let coffeeMarkerIconStyle = {
			url: assetsDirectory + 'images/store-marker-coffee.png',
			size: new window.google.maps.Size(44, 60),
			origin: new window.google.maps.Point(0, 0),
			anchor: new window.google.maps.Point(22, 60),
			scaledSize: new window.google.maps.Size(44, 60),
		};
		// closed marker style
		let closedMarkerIconStyle = {
			url: assetsDirectory + 'images/store-marker-closed.png',
			size: new window.google.maps.Size(44, 60),
			origin: new window.google.maps.Point(0, 0),
			anchor: new window.google.maps.Point(22, 60),
			scaledSize: new window.google.maps.Size(44, 60),
		};
		// offline marker style
		let offlineMarkerIconStyle = {
			url: assetsDirectory + 'images/store-marker-offline.png',
			size: new window.google.maps.Size(44, 60),
			origin: new window.google.maps.Point(0, 0),
			anchor: new window.google.maps.Point(22, 60),
			scaledSize: new window.google.maps.Size(44, 60),
		};
		// cluster icon style
		let clusterIconStyle = {
			textColor: 'transparent', // hide cluster count text
			url: assetsDirectory + 'images/store-marker.svg', //use svg version for retina
			height: 60,
			width: 44,
		};

		// run through stores and create markers for each to be included in MarkerClusterer
		this.markers = storesToMarkers.map((store) => {
			// New store marker options and setup
			let newMarker = new window.google.maps.Marker({
				store: store,
				position: {
					lat: Number(store.location.lat),
					lng: Number(store.location.long),
				},
				icon: store.hours.temp_close
					? closedMarkerIconStyle
					: store.facilities.preorder
					? store.facilities.barista_coffee
						? coffeeMarkerIconStyle
						: markerIconStyle
					: offlineMarkerIconStyle,
				//animation: window.google.maps.Animation.DROP,
				//label: store.name
			});

			// click event binding for store marker
			if (!store.hours.temp_close) {
				// only apply store marker click event if store not closed
				window.google.maps.event.addListener(newMarker, 'click', () => {
					//this.storeMarkerClicked(store, newMarker);
					this.toggleStoreResultExpand(store);
				});
				//pin hover binding
				window.google.maps.event.addListener(newMarker, 'mouseover', () => {
					this.newMarkerLabel(store);
				});
				window.google.maps.event.addListener(newMarker, 'mouseout', () => {
					this.resetStoreHover();
				});
			}

			return newMarker;
		});

		// Add a marker clusterer to manage the markers
		this.markerCluster = new window.MarkerClusterer(this.map, this.markers, {
			maxZoom: this.locationZoom - 1, // one less than location zoom so no cluster are seen
			gridSize: 30, //30
			styles: [clusterIconStyle, clusterIconStyle, clusterIconStyle], //same cluster styles for each size cluster
		});

		if (this.filteredStores) {
			// set state for markers(stores) within map viewport bounds and display in side bar
			this.setStoreResults(this.filteredStores);
		}
	}

	geocodeAddress(address) {
		var geocoder = new window.google.maps.Geocoder();

		geocoder.geocode(
			{
				address: address,
			},
			(results, status) => {
				if (status === 'OK') {
					if (results[0]) {
						this.newLocation(results[0]);
					}
				} else {
					window.alert('Geocoder failed due to: ' + status);
				}

				setTimeout(() => {
					this.setState({
						loading: false,
					});
				}, 1000);
			}
		);
	}

	newLocation(location) {
		// set location in url hash
		document.location.hash = encodeURIComponent(location.formatted_address);

		// update new location in state
		this.setState({
			searchLocation: location,
		});

		// zoom and center map on new location
		this.map.setZoom(this.locationZoom);

		// offset center map for top nav and sidebar
		let latlng = new window.google.maps.LatLng(
			location.geometry.location.lat(),
			location.geometry.location.lng()
		);
		this.map.setCenter(this.offsetCenterMap(latlng));

		this.state.filters.forEach((filter) => {
			// log barista coffee filter braze event
			if (filter.name === 'barista_coffee' && filter.checked) {
				appboyLogCustomEvent('CoffeeLoyaltySearchFilterApplied');
			}
		});
	}

	resetSearch() {
		// clear search value (which returns to landing state/view)
		this.setState({
			searchLocation: null,
		});
		// reset map to initial zoom and position
		this.map.setCenter(this.centerPosition);
		this.map.setZoom(this.initialZoom);
	}

	offsetCenterMap(latlng) {
		let offsetx;
		let offsety;

		if (window.isMobileMode()) {
			// set map offset based on mobile map element
			offsetx = 0;
			offsety = 0;
		} else {
			// set map offset based off side bar
			offsetx = (this.$sidebar.offsetWidth + this.$sidebar.offsetLeft) / 2;
			offsety = -(this.$sidebar.offsetTop / 2);
		}

		let point1 = this.map
			.getProjection()
			.fromLatLngToPoint(
				latlng instanceof window.google.maps.LatLng
					? latlng
					: this.map.getCenter()
			);
		let point2 = new window.google.maps.Point(
			(typeof offsetx === 'number' ? offsetx : 0) /
				Math.pow(2, this.map.getZoom()) || 0,
			(typeof offsety === 'number' ? offsety : 0) /
				Math.pow(2, this.map.getZoom()) || 0
		);

		return this.map
			.getProjection()
			.fromPointToLatLng(
				new window.google.maps.Point(point1.x - point2.x, point1.y + point2.y)
			);
	}

	setStoreResults(stores, clickedStore) {
		if (this.state.searchLocation) {
			let storeResults = [];
			// reset store results
			this.setState({
				storeResults: [],
			});

			// offset center map for top nav and sidebar
			let searchLocationLatLng = new window.google.maps.LatLng(
				this.state.searchLocation.geometry.location.lat(),
				this.state.searchLocation.geometry.location.lng()
			);

			// scroll to top of store results list
			document.getElementById('store-finder-results').scrollTop = 0;

			// find stores located within viewable map bounds
			stores.map((store) => {
				if (store.location) {
					let storeLatLng = new window.google.maps.LatLng(
						Number(store.location.lat),
						Number(store.location.long)
					);

					if (clickedStore && clickedStore.name === store.name) {
						// clickedStore provided, set expanded state of store result to true
						store.isExpanded = true;
					} else {
						store.isExpanded = false;
					}

					//TODO UPDATE GET BOUNDS TO OFFSET SIDEBAR
					if (this.map.getBounds().contains(storeLatLng)) {
						// current map bounds contain this store latlng
						store.proximity =
							window.google.maps.geometry.spherical.computeDistanceBetween(
								searchLocationLatLng,
								storeLatLng
							);
						storeResults.push(store);
					}
				}
			});

			// sort stores by proximity to center of viewable map bounds
			storeResults.sort(function (a, b) {
				return a.proximity - b.proximity;
			});

			// trim sorted results to first 10 and set in state
			this.setState({
				storeResults: storeResults.slice(0, this.maxResults),
			});
		}
	}

	isInfoWindowOpen(infoWindow) {
		var map = infoWindow.getMap();
		return map !== null && typeof map !== 'undefined';
	}

	newMarkerLabel(store, isActive) {
		const latlng = new window.google.maps.LatLng(
			Number(store.location.lat),
			Number(store.location.long)
		);
		const markerInfoWindow = new window.google.maps.InfoWindow({
			content: `<div class="store-marker-label">${store.name}</div>`,
		});

		let storeMarker;
		for (let marker of this.markers) {
			if (marker.store.store_id === store.store_id) {
				storeMarker = marker;
				break;
			}
		}

		// if new marker label is for an active (clicked) store
		if (isActive) {
			// Close active store marker label
			if (this.activeMarkerLabel) {
				this.activeMarkerLabel.close();
			}
			// set info window label to active store
			this.activeMarkerLabel = markerInfoWindow;
			// open marker on active store
			this.activeMarkerLabel.open(this.map, storeMarker);
			// set map zoom on active store
			this.map.setZoom(this.locationZoom + 1);
			// center map on active store
			this.map.setCenter(this.offsetCenterMap(latlng));
		} else if (this.state.activeStore !== store.name) {
			// normal hover label
			if (this.markerLabel) {
				this.markerLabel.close();
			}
			this.markerLabel = markerInfoWindow;
			// Open clicked marker label
			this.markerLabel.open(this.map, storeMarker);
		}
	}

	resetStoreHover() {
		if (this.markerLabel) {
			this.markerLabel.close();
		}
	}

	filterChange(event, changedFilter) {
		let updatedFilters = [];
		let activeFilterCount = 0;

		this.state.filters.map((filter) => {
			// update matching filter checked status
			if (changedFilter.name === filter.name) {
				filter.checked = event.target.checked;
			}
			updatedFilters.push(filter);
			// count active filters
			if (filter.checked) {
				activeFilterCount++;
			}
		});

		this.setState({
			filters: updatedFilters,
			activeFilterCount: activeFilterCount,
		});

		this.filterStores(updatedFilters);

		// log barista coffee filter braze event
		if (changedFilter.name === 'barista_coffee') {
			appboyLogCustomEvent('CoffeeLoyaltySearchFilterApplied');
		}
	}

	filterStores(newFilters) {
		// set hidden value per store if not matching filters
		let storesFiltered = this.stores.map((store) => {
			store.filtered = false;

			for (let filter of newFilters) {
				if (filter.checked && store.facilities[filter.name] === false) {
					// store does not have checked filter/facility so mark to be filtered out
					store.filtered = true;
				}
			}

			return store;
		});

		//new filtered stores array (will contain only visible stores)
		this.filteredStores = [];
		for (let store of storesFiltered) {
			if (!store.filtered) {
				this.filteredStores.push(store);
			}
		}

		// update store markers/clusters to map
		this.updateStoreMarkers();
	}

	toggleFilterExpand() {
		this.setState({
			filtersExpanded: !this.state.filtersExpanded ? true : false,
		});
	}

	toggleStoreResultExpand(storeToToggle) {
		if (
			!this.state.activeStore ||
			this.state.activeStore !== storeToToggle.name
		) {
			this.setState({
				activeStore: storeToToggle.name,
			});
			// open marker label on store marker
			this.newMarkerLabel(storeToToggle, true);
		} else {
			this.setState({
				activeStore: null,
			});
			// Close active store marker label
			if (this.activeMarkerLabel) {
				this.activeMarkerLabel.close();
			}
		}

		this.resetStoreHover();
	}

	setSidebarScrollHeight() {
		this.setState({
			sidebarPaddingTop: this.$sidebarTop ? this.$sidebarTop.clientHeight : 0,
		});
	}

	weekdaysFromToday() {
		let d = new Date();
		let weekday = new Array(7);
		weekday[0] = [0, 'Sun'];
		weekday[1] = [1, 'Mon'];
		weekday[2] = [2, 'Tue'];
		weekday[3] = [3, 'Wed'];
		weekday[4] = [4, 'Thu'];
		weekday[5] = [5, 'Fri'];
		weekday[6] = [6, 'Sat'];

		//let currentDay = weekday[d.getDay()];

		// return array of days of the week starting from the current day
		return weekday.slice(d.getDay()).concat(weekday.slice(0, d.getDay()));
	}

	convert24hrtoAmPm(time) {
		// Check correct time format and split into components
		if (time) {
			time = time
				.toString()
				.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

			if (time.length > 1) {
				// If time format correct
				time = time.slice(1); // Remove full string match value
				time[5] = +time[0] < 12 ? 'am' : 'pm'; // Set AM/PM
				time[0] = +time[0] % 12 || 12; // Adjust hours
			}
			return time.join(''); // return adjusted time or original string
		}
	}

	renderLanding() {
		let viewState = !this.state.searchLocation ? 'is-active' : 'is-hidden';
		return (
			<div className={`store-finder-landing ${viewState}`}>
				<div className="container-fluid-sm center-xs">
					<div className="store-finder-landing-inner">
						<div className="priority-4">Find your nearest restaurant</div>
						<LocationSearch
							geolocateOnInit={this.autoGeolocate}
							locationSelect={this.newLocation}
							currentLocation={this.state.searchLocation}
						/>
					</div>
				</div>
			</div>
		);
	}

	renderStoreResult(store, key) {
		let storeExpandClass =
			this.state.activeStore && this.state.activeStore === store.name
				? 'is-expanded'
				: '';
		let storeScrollToClass =
			this.state.activeStore && this.state.activeStore === store.name
				? 'is-scroll-to'
				: '';
		let storeClosedClass = store.hours.temp_close ? 'is-closed' : '';

		return (
			<div
				className={`store-result ${storeExpandClass} ${storeScrollToClass} ${storeClosedClass}`}
				key={key}
				onMouseEnter={() => this.newMarkerLabel(store)}
				onMouseLeave={() => this.resetStoreHover()}
				onClick={() => this.toggleStoreResultExpand(store)}
			>
				<div className="store-result-header">
					{store.name}
					<span className="store-result-proximity">
						{Math.round((store.proximity / 1000) * 100) / 100}km
					</span>
				</div>
				<div className="store-result-address">{store.location.address}</div>
				<div className="store-result-expandable">
					<div className="store-result-expand-btn icon icon-arrow-down is-clickable" />
					<table className="store-result-hours">
						<tbody>
							<tr>
								<th />
								<th>TAKE AWAY</th>
								<th>DRIVE THRU</th>
							</tr>
							{this.weekdaysFromToday().map((day, key) => {
								return (
									<tr key={key}>
										<td>{day[1]}</td>
										{_.get(store, 'hours.dine_in[' + day[0] + '].is_open') ? (
											<td>
												{this.convert24hrtoAmPm(
													store.hours.dine_in[day[0]].open
												)}
												-
												{this.convert24hrtoAmPm(
													store.hours.dine_in[day[0]].close
												)}
											</td>
										) : (
											<td>Closed</td>
										)}
										{_.get(
											store,
											'hours.drive_thru[' + day[0] + '].is_open'
										) ? (
											<td>
												{this.convert24hrtoAmPm(
													store.hours.drive_thru[day[0]].open
												)}
												-
												{this.convert24hrtoAmPm(
													store.hours.drive_thru[day[0]].close
												)}
											</td>
										) : (
											<td>Closed</td>
										)}
									</tr>
								);
							})}
						</tbody>
					</table>
					<div className="store-result-features">
						<div className="store-result-facilities">
							{this.state.filters.map((filter, key) => {
								if (store.facilities[filter.name]) {
									return (
										<div
											className="store-result-facility"
											title={filter.label}
											key={key}
										>
											<span className={`icon ${filter.icon}`} />
											<span className="store-result-facility-text">
												{filter.label}
											</span>
										</div>
									);
								}
							})}
						</div>
						{/* {window.onlineOrderingURL ? (
							<a
								className={'store-result-order-now'}
								onClick={(event) => {
									event.stopPropagation();
								}}
								target="_blank"
								href={window.onlineOrderingURL}
							>
								Order Now
							</a>
						) : null} */}
					</div>
					<div className="store-result-links">
						<div className="row">
							<div className="col-xs-6">
								<a
									onClick={(event) => {
										event.stopPropagation();
									}}
									href={store.storeUrl ? store.storeUrl : '/' + store.name}
									className="icon icon-arrow"
								>
									View detail page
								</a>
							</div>
							<div className="col-xs-6">
								<a
									onClick={(event) => {
										event.stopPropagation();
									}}
									href={`https://www.google.com/maps/dir//${store.location.lat},${store.location.long}/@${store.location.lat},${store.location.long},16.73z`}
									target="_blank"
									className="icon icon-map-hollow"
								>
									Get directions
								</a>
							</div>
						</div>
					</div>
				</div>
				{store.hours.temp_close ? (
					<div className="store-result-closed">
						RESTAURANT TEMPORARILY CLOSED
					</div>
				) : null}
			</div>
		);
	}

	renderSidebar() {
		let viewStateClass = this.state.searchLocation ? 'is-active' : 'is-hidden';
		let paddingTop = this.state.sidebarPaddingTop
			? this.state.sidebarPaddingTop
			: 0;
		return (
			<div
				ref={(sidebar) => {
					this.$sidebar = sidebar;
				}}
				className={`store-finder-sidebar ${viewStateClass}`}
				style={{ paddingTop: paddingTop + 'px' }}
			>
				<div
					className="store-finder-sidebar-top"
					ref={(sidebarTop) => {
						this.$sidebarTop = sidebarTop;
					}}
				>
					<LocationSearch
						locationSelect={this.newLocation}
						currentLocation={this.state.searchLocation}
						value={this.state.searchValue}
					/>

					<div
						className={`store-finder-filters ${
							this.state.filtersExpanded ? 'is-expanded' : ''
						}`}
					>
						<div className="store-finder-filters-checkboxes">
							<div className="store-finder-filters-label">
								<span className="icon icon-filters" />
								Filters
							</div>
							{this.state.filters.map((filter, key) => {
								return (
									<label key={key} title={filter.label}>
										<input
											onChange={(event) => this.filterChange(event, filter)}
											type="checkbox"
										/>
										<span className="checkbox-input icon icon-tick" />
										<span className={`icon ${filter.icon}`} />
										<span className="filter-text">{filter.label}</span>
									</label>
								);
							})}
							<div
								onClick={() => this.toggleFilterExpand()}
								className="filter-expand-btn icon icon-arrow-down is-clickable"
							/>
						</div>

						<div className="store-finder-filters-summary">
							{this.state.activeFilterCount ? (
								<span>
									{this.state.activeFilterCount} filter
									{this.state.activeFilterCount > 1 ? 's' : null} applied |{' '}
								</span>
							) : null}
							<strong>{this.state.storeResults.length} results</strong>
						</div>
					</div>
				</div>

				<div id="store-finder-results" className="store-finder-results">
					{this.state.storeResults
						? this.state.storeResults.map((store, key) => {
								return this.renderStoreResult(store, key);
						  })
						: null}
				</div>
			</div>
		);
	}

	render() {
		let containerOverflow = this.state.searchLocation ? 'has-overflow' : '';
		return (
			<div
				id="store-finder-container"
				className={`store-finder-container ${containerOverflow}`}
			>
				<div
					className={`store-finder-map-wrapper ${
						this.state.searchLocation ? 'has-location' : ''
					}`}
				>
					<div id="store-finder-map" className="store-finder-map" />
					{this.state.searchLocation ? (
						<div
							onClick={() => this.resetSearch()}
							className="store-finder-back-btn is-clickable"
						>
							<span className="icon icon-arrow" />
							Back
						</div>
					) : null}
				</div>

				{this.renderLanding()}

				{this.renderSidebar()}

				{this.state.loading ? (
					<div className="store-finder-loader">
						<div className="loader">Loading...</div>
					</div>
				) : null}
			</div>
		);
	}
}

if (storeFinderEl) {
	render(<StoreFinder />, storeFinderEl);
}
